import { Component, Input } from '@angular/core';
import { ReportOptions } from '@src/app/features/reports/models/reports.model';

import { PermittedDirective } from '@core/permissions/permitted.directive';
import { RouterLink } from '@angular/router';
import { ValueSeparatorComponent } from '@shared/modules/general-commons/components/value-separator/value-separator.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-report-link-list',
  templateUrl: './report-link-list.component.html',
  imports: [PermittedDirective, RouterLink, ValueSeparatorComponent, TranslateModule]
})
export class ReportLinkListComponent {
  @Input() options: ReportOptions[];
}
